<!-- App Main Structure -->
<template>
  <div class="app-horizontal-layout">
    <template v-if="loading">
      <rotate-square2></rotate-square2>
    </template>
    <template v-else>
      <!-- App Header -->
      <app-header :horizontal="true"></app-header>
      <app-horizontal-menus />
      <v-navigation-drawer absolute temporary v-model="horizontalLayoutSidebar" :width="250">
        <app-sidebar></app-sidebar>
      </v-navigation-drawer>
      <!-- App Main Content -->
      <v-content>
        <!-- App Router -->
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-content>
      <user-settings></user-settings>
    </template>
  </div>
</template>

<script>
import AppHeader from 'Components/Header/Header.vue'
import Customizer from 'Components/Customizer/Customizer'
import AppHorizontalMenus from 'Components/AppHorizontalMenus/AppHorizontalMenus'
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar'
import { mapGetters } from 'vuex'
import Sidebar from 'Components/Sidebar/Sidebar'
import UserSettings from 'Components/UserSettings/UserSettings'

export default {
    data() {
        return {
        loading: false
        };
    },
    components: {
        AppHeader,
        appCustomizer: Customizer,
        appHorizontalMenus: AppHorizontalMenus,
        PageTitleBar,
        appSidebar: Sidebar,
        UserSettings
    },
    sockets: {
        requestAuthorization: function () {
            this.sendAuthorization()
        }
    },
    mounted() {
        setTimeout(() => {
            this.loading = false;
        }, 2000);

        // Load Reports for logged in user
        this.sendAuthorization()
        this.$store.dispatch('getReportsForUser')
        this.$store.dispatch('getCompanies')
        this.$store.dispatch('getArticleTypes')
        this.$auth.me()
    },
    computed: {
        ...mapGetters([
            'selectedRouterAnimation',
            'accessToken',
            'refreshToken'
        ]),
        horizontalLayoutSidebar: {
            get() {
                return this.$store.getters.horizontalLayoutSidebar
            },
            set(val) {
                this.$store.dispatch('toggleHorizontalLayoutSidebar', val)
            }
        },
        // computed property to get page breadcrumbs
        pageTitle() {
            return this.$breadcrumbs[0].meta.title
        },
        pageBreadcrumb() {
            return this.$breadcrumbs[0].meta.breadcrumb
        }
    },
    methods: {
        sendAuthorization () {
            this.$socket.emit('authorize', {
                accessToken: this.accessToken,
                refreshToken: this.refreshToken
            })
        }
    }
}
</script>

<style scoped>
.app-horizontal-layout {
  height: 100vh;
}
</style>

